'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { VStack } from '@terra/ui-styled-system';
import { MetaDefault } from '../../../components/typography';
import { SettingsCard } from '../../settings/SettingsCard';
import { SettingsSection } from '../../settings/SettingsSection';

export type ApplicationSourceCodeSectionProps = {
  isLoading: boolean;
  isEmpty: boolean;
  action?: ReactNode;
  emptyContent?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
};

export function ApplicationSourceCodeSection({
  isLoading,
  isEmpty,
  action,
  emptyContent,
  footer,
  children,
}: ApplicationSourceCodeSectionProps) {
  const t = useTranslations('designSystem.applicationSettings.sourceCode');

  return (
    <VStack gap={8} alignItems="stretch" w="full">
      <SettingsSection
        title={t('title')}
        description={isEmpty && !isLoading ? t('emptyDescription') : undefined}
        action={action}
      >
        {isLoading ? (
          <SettingsCard isLoading>{null}</SettingsCard>
        ) : isEmpty ? (
          <SettingsCard>
            {emptyContent ?? (
              <MetaDefault color="fg.muted">{t('noIntegrations')}</MetaDefault>
            )}
          </SettingsCard>
        ) : (
          <VStack gap={4} alignItems="stretch">
            {children}
          </VStack>
        )}
      </SettingsSection>
      {footer}
    </VStack>
  );
}
